var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.82143C5.88432 8.82143 5.29385 8.57685 4.8585 8.1415C4.42315 7.70615 4.17857 7.11568 4.17857 6.5C4.17857 5.88432 4.42315 5.29385 4.8585 4.8585C5.29385 4.42315 5.88432 4.17857 6.5 4.17857C7.11568 4.17857 7.70615 4.42315 8.1415 4.8585C8.57685 5.29385 8.82143 5.88432 8.82143 6.5C8.82143 6.80485 8.76138 7.10672 8.64472 7.38837C8.52806 7.67002 8.35706 7.92593 8.1415 8.1415C7.92593 8.35706 7.67002 8.52806 7.38837 8.64472C7.10672 8.76138 6.80485 8.82143 6.5 8.82143ZM6.5 0C4.77609 0 3.12279 0.684819 1.90381 1.90381C0.684819 3.12279 0 4.77609 0 6.5C0 11.375 6.5 18.5714 6.5 18.5714C6.5 18.5714 13 11.375 13 6.5C13 4.77609 12.3152 3.12279 11.0962 1.90381C9.87721 0.684819 8.22391 0 6.5 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.af3fb518d03263b68e1a54015049ba6e.svg";
export { ForwardRef as ReactComponent };